import script from "./DemoDashboardsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoDashboardsPage.vue?vue&type=script&setup=true&lang=ts"

import "./DemoDashboardsPage.vue?vue&type=style&index=0&id=1dfd8dea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfd8dea"]])

export default __exports__